import React, {Component} from 'react';
import './style.scss';
import LogoImageA from "../../../resources/images/ShipitLogo.png";
import SentimentVeryDissatisfiedIcon from '@material-ui/icons/SentimentVeryDissatisfied';

export default class MainErrorHandler extends Component {
    constructor(props) {
        super(props)
        this.state = {errorOccurred: false}
    }

    componentDidCatch(error, info) {
        if (!localStorage.getItem('didErrorRefresh')) {
            localStorage.setItem('didErrorRefresh', '1');
            window.location.reload();
        } else {
            this.setState({errorOccurred: true});

            this.props.logError(error.name, error.message, error.stack, true);
        }
    }

    render() {
        if (!this.state.errorOccurred)
            return this.props.children;

        return (
            <div className="error-page">
                <div className="logo">
                    <img src={LogoImageA} alt="Shipit"/>
                </div>
                <div className="contact-support-text-container">
                    <div className="contact-support-text">
                        אוי לא! אירעה שגיאה&nbsp;<SentimentVeryDissatisfiedIcon/>
                    </div>
                    <div className="contact-support-text">
                        אנא פנו לצוות Shipit לפתרון התקלה
                    </div>
                </div>
            </div>
        );
    }
}

const ERROR_REFRESH_AFTER_MILLISECONDS = 5000;

if (localStorage.getItem("didErrorRefresh") !== null) {
    setTimeout(() => {
        localStorage.removeItem("didErrorRefresh");
    }, ERROR_REFRESH_AFTER_MILLISECONDS)
}